module.exports = __webpack_public_path__ + "static/img/integracija-3-SMALL.83b0749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integracija-3-SMALL.jpg
// module id = Gmm8
// module chunks = 9